import * as React from "react";
import { ContractSpecsTabs } from "../ContractSpecsTabs";
import { DEFAULT_CS_PAGE_CONFIG } from "./config";
export const ContractSpecsSBTabs = (props) => React.createElement(ContractSpecsTabs, { ...props, pageConfig: DEFAULT_CS_PAGE_CONFIG });
